"use client";
import { jsx as o } from "react/jsx-runtime";
import { useState as a } from "react";
import { Tooltip as p, Button as l } from "@zapier/design-system-beta";
import { Icon as s } from "@zapier/design-system";
import { e as u } from "../../emitEvent-B5xAYp5K.mjs";
import { UserInteractionEventName as m } from "../../observability/tracking/trackingTypes.es.js";
var S = function(r) {
  var i = r.slug, e = a(""), n = e[0], t = e[1];
  return /* @__PURE__ */ o(p, { content: n, isOpen: !!n, children: /* @__PURE__ */ o(l, { iconStart: /* @__PURE__ */ o(s, { name: "personGroup", size: 16 }), onPress: function() {
    navigator.clipboard.writeText(window.location.href).then(function() {
      u(m.templateShareButtonClicked, {
        event_action: "click",
        option_selected: i
      }), t("Link copied to clipboard"), setTimeout(function() {
        return t("");
      }, 2e3);
    }).catch(function(c) {
      console.error("Failed to copy:", c), t("Failed to copy"), setTimeout(function() {
        return t("");
      }, 2e3);
    });
  }, variant: "secondary", children: "Share" }) });
};
export {
  S as ShareButton
};
//# sourceMappingURL=ShareButton.es.js.map
